import { render, staticRenderFns } from "./TncAbac.vue?vue&type=template&id=d459e542&"
import script from "./TncAbac.vue?vue&type=script&lang=js&"
export * from "./TncAbac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports